package com.loyola.acessoescola.ui.addnew

import acessoescola.composeapp.generated.resources.Authorized_data
import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.bound
import acessoescola.composeapp.generated.resources.call_24px
import acessoescola.composeapp.generated.resources.cancel
import acessoescola.composeapp.generated.resources.cpf
import acessoescola.composeapp.generated.resources.full_name
import acessoescola.composeapp.generated.resources.id_card_24px
import acessoescola.composeapp.generated.resources.person_24px
import acessoescola.composeapp.generated.resources.phone
import acessoescola.composeapp.generated.resources.save
import acessoescola.composeapp.generated.resources.sync_24px
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ElevatedFilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bn.easymediapicker.core.MediaResult
import com.loyola.acessoescola.ui.CPFVisualTransformation
import com.loyola.acessoescola.ui.CellphoneVisualTransformation
import com.loyola.acessoescola.ui.components.ErrorDialog
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
fun AddNewScreen(
    addNewViewModel: AddNewViewModel,
    navigateToRegistered: () -> Unit,
    paddingValues: PaddingValues,
    activeRecordID: String? = null
) {
    val uiState by addNewViewModel.uiState.collectAsState()
    var selectedImage by remember { mutableStateOf<MediaResult?>(null) }
    val scope = rememberCoroutineScope()
    var errorMessage by remember { mutableStateOf("") }

    val infiniteTransition = rememberInfiniteTransition()

    val rotation by infiniteTransition.animateFloat(
        initialValue = 0f,
        targetValue = -360f,
        animationSpec = infiniteRepeatable(
            animation = tween(2500, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        )
    )

    if (errorMessage != "") {
        ErrorDialog(
            errorMessage = errorMessage,
            onErrorMessageChange = { errorMessage = it }
        )
    }

    val isLoading = !activeRecordID.isNullOrBlank() && uiState.fullName.isBlank()

    LaunchedEffect(activeRecordID) {
        addNewViewModel.resetState()
        if (activeRecordID != null) {
            addNewViewModel.stateFromRecordID(recordID = activeRecordID) { errorMessage = it }
        }
    }


    selectedImage?.let { image ->
        scope.launch {
            addNewViewModel.onPhotoUriChange(image.uri)
        }
    }

    Scaffold(
        modifier = Modifier.padding(paddingValues)
    ) { paddingValues ->
        Column(
            modifier = Modifier.padding(paddingValues)
                .padding(horizontal = 16.dp)
                .verticalScroll(rememberScrollState())
        ) {
            Row(
                modifier = Modifier.height(intrinsicSize = IntrinsicSize.Min),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(text = stringResource(Res.string.Authorized_data))
                if (isLoading) {
                    Icon(
                        imageVector = vectorResource(Res.drawable.sync_24px),
                        contentDescription = null,
                        modifier = Modifier.rotate(rotation)
                    )
                }
            }

            HorizontalDivider()

            OutlinedTextField(
                value = uiState.fullName,
                onValueChange = { addNewViewModel.onFullNameChange(it) },
                label = { Text(text = stringResource(Res.string.full_name)) },
                leadingIcon = {
                    Icon(
                        imageVector = vectorResource(Res.drawable.person_24px),
                        contentDescription = stringResource(Res.string.full_name)
                    )
                },
                modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                keyboardOptions = KeyboardOptions.Default.copy(
                    imeAction = ImeAction.Next
                ),
                isError = uiState.fullNameError,
                enabled = !isLoading
            )

            OutlinedTextField(
                value = uiState.cpf,
                onValueChange = { addNewViewModel.onCpfChange(it.filter { char -> char.isDigit() }) },
                label = { Text(text = stringResource(Res.string.cpf)) },
                leadingIcon = {
                    Icon(
                        imageVector = vectorResource(Res.drawable.id_card_24px),
                        contentDescription = stringResource(Res.string.cpf)
                    )
                },
                modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                keyboardOptions = KeyboardOptions.Default.copy(
                    imeAction = ImeAction.Next,
                    keyboardType = KeyboardType.Number
                ),
                visualTransformation = CPFVisualTransformation(),
                isError = uiState.cpfError,
                enabled = !isLoading
            )

            OutlinedTextField(
                value = uiState.phone,
                onValueChange = { addNewViewModel.onPhoneChange(it.filter { char -> char.isDigit() }) },
                label = { Text(text = stringResource(Res.string.phone)) },
                leadingIcon = {
                    Icon(
                        imageVector = vectorResource(Res.drawable.call_24px),
                        contentDescription = stringResource(Res.string.phone)
                    )
                },
                modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                keyboardOptions = KeyboardOptions.Default.copy(
                    imeAction = ImeAction.Done,
                    keyboardType = KeyboardType.Number
                ),
                visualTransformation = CellphoneVisualTransformation(),
                isError = uiState.phoneError,
                enabled = !isLoading
            )


            Column(
                modifier = if (uiState.boundError) {
                    Modifier
                        .border(
                            width = 1.dp,
                            color = MaterialTheme.colorScheme.error,
                            shape = RoundedCornerShape(10.dp)
                        )
                } else {
                    Modifier
                }
            ) {
                Text(
                    text = stringResource(Res.string.bound),
                    modifier = Modifier.padding(horizontal = 4.dp)
                )

                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    modifier = Modifier.padding(horizontal = 4.dp)
                ) {
                    items(Bounds.entries.filter { it.string != "" }) { bound ->
                        ElevatedFilterChip(
                            selected = uiState.bound == bound.string,
                            onClick = { addNewViewModel.onBoundChange(bound.string) },
                            label = { Text(text = bound.string) },
                            enabled = !isLoading
                        )
                    }
                }
            }

            ImageField(
                onImagePick = { selectedImage = it },
                photoBitmap = uiState.photoBitmap,
                isError = uiState.photoError
            )

            Row {
                Button(
                    onClick = {
                        addNewViewModel.saveRecord(onErrorCallback = { errorMessage = it }) {
//                            addNewViewModel.resetState()
                            navigateToRegistered()
                        }
                    },
                    modifier = Modifier.weight(0.5f).padding(end = 4.dp),
                    enabled = !uiState.saveRequested && !isLoading
                ) {
                    Row(
                        modifier = Modifier.height(intrinsicSize = IntrinsicSize.Min),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (uiState.saveRequested) {
                            Icon(
                                imageVector = vectorResource(Res.drawable.sync_24px),
                                contentDescription = null,
                                modifier = Modifier.rotate(rotation)
                            )
                        }
                        Text(text = stringResource(Res.string.save))
                    }
                }
                Button(
                    onClick = {
                        navigateToRegistered()
                    },
                    modifier = Modifier.weight(0.5f)
                ) {
                    Text(text = stringResource(Res.string.cancel))
                }
            }

        }
    }
}


@Composable
expect fun ImageField(
    onImagePick: (MediaResult?) -> Unit,
    photoBitmap: ImageBitmap?,
    isError: Boolean
)

@Preview
@Composable
private fun AddNewScreenPreview() {
    AcessoEscolaTheme {
//        AddNewScreen(
//            createAddNewViewModel(),
//            navigateToRegistered = {  },
//            paddingValues = PaddingValues(0.dp)
//        )
    }
}